/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  // Blog Live Search
  (function () {
    const searchInput = document.getElementById("blog-search-input");
    const resultsContainer = document.getElementById("blog-search-results");

    if (!searchInput || !resultsContainer) return;

    let searchTimeout;
    let currentRequest = null;

    function debounce(func, wait) {
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(searchTimeout);
          func(...args);
        };
        clearTimeout(searchTimeout);
        searchTimeout = setTimeout(later, wait);
      };
    }

    function formatDate(dateString) {
      const date = new Date(dateString);
      const options = { year: "numeric", month: "long", day: "numeric" };
      return date.toLocaleDateString("bg-BG", options);
    }

    function truncateText(text, maxWords) {
      if (!text) return "";
      const words = text.split(" ");
      if (words.length <= maxWords) return text;
      return words.slice(0, maxWords).join(" ") + "...";
    }

    function escapeHtml(text) {
      const div = document.createElement("div");
      div.textContent = text;
      return div.innerHTML;
    }

    function renderResults(articles) {
      if (articles.length === 0) {
        resultsContainer.innerHTML =
          '<div class="blog-search-no-results">Няма намерени резултати</div>';
        resultsContainer.classList.add("has-results");
        resultsContainer.style.display = "block";
        return;
      }

      let html = '<div class="blog-search-results-list">';

      articles.forEach(function (article) {
        let imageUrl = "";
        if (article.image) {
          imageUrl =
            typeof article.image === "string"
              ? article.image
              : article.image.src || article.image.url || "";
        }
        const imageAlt = escapeHtml(article.image_alt || article.title || "");
        const excerpt = truncateText(
          article.excerpt || article.body || article.summary || "",
          20,
        );
        const date = article.published_at
          ? formatDate(article.published_at)
          : "";
        const title = escapeHtml(article.title || "");
        const url = article.url || "#";

        html += `
          <article class="blog-search-result-item">
            ${
              imageUrl
                ? `
            <div class="blog-search-result-image">
              <a href="${url}">
                <img src="${imageUrl}" alt="${imageAlt}" loading="lazy" />
              </a>
            </div>
            `
                : ""
            }
            <div class="blog-search-result-content">
              <h3 class="blog-search-result-title">
                <a href="${url}">${title}</a>
              </h3>
              ${date ? `<time class="blog-search-result-date">${date}</time>` : ""}
              ${excerpt ? `<p class="blog-search-result-excerpt">${excerpt}</p>` : ""}
              <a href="${url}" class="blog-search-result-link">Прочетете още</a>
            </div>
          </article>
        `;
      });

      html += "</div>";
      resultsContainer.innerHTML = html;
      resultsContainer.classList.add("has-results");
      resultsContainer.style.display = "block";
    }

    function performSearch(query) {
      if (!query || query.trim().length < 2) {
        resultsContainer.innerHTML = "";
        resultsContainer.classList.remove("has-results");
        resultsContainer.style.display = "none";
        return;
      }

      // Cancel previous request if still pending
      if (currentRequest && currentRequest.abort) {
        currentRequest.abort();
      }

      resultsContainer.innerHTML =
        '<div class="blog-search-loading">Търсене...</div>';
      resultsContainer.classList.add("has-results", "loading");
      resultsContainer.style.display = "block";

      const searchUrl = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=article&resources[limit]=6`;

      const controller = new AbortController();
      currentRequest = controller;

      fetch(searchUrl, {
        signal: controller.signal,
        headers: {
          Accept: "application/json",
        },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return response.json();
        })
        .then((data) => {
          let articles = [];

          // Try different possible response structures
          if (
            data.resources &&
            data.resources.results &&
            data.resources.results.articles
          ) {
            articles = data.resources.results.articles;
          } else if (data.resources && Array.isArray(data.resources)) {
            articles = data.resources.filter((r) => r.type === "article");
          } else if (Array.isArray(data.articles)) {
            articles = data.articles;
          } else if (data.articles) {
            articles = Array.isArray(data.articles)
              ? data.articles
              : [data.articles];
          }

          renderResults(articles);
          resultsContainer.classList.remove("loading");
          currentRequest = null;
        })
        .catch((error) => {
          if (error.name !== "AbortError") {
            console.error("Search error:", error);
            // Fallback: try direct search URL
            const fallbackUrl = `/search?type=article&q=${encodeURIComponent(query)}`;
            resultsContainer.innerHTML = `<div class="blog-search-error">Грешка при търсене. <a href="${fallbackUrl}" style="text-decoration: underline;">Отидете към search страницата</a></div>`;
            resultsContainer.classList.remove("loading");
          }
          currentRequest = null;
        });
    }

    const debouncedSearch = debounce(performSearch, 300);

    searchInput.addEventListener("input", function (e) {
      const query = e.target.value.trim();
      debouncedSearch(query);
    });

    searchInput.addEventListener("focus", function (e) {
      const query = e.target.value.trim();
      if (
        query.length >= 2 &&
        resultsContainer.classList.contains("has-results")
      ) {
        resultsContainer.style.display = "block";
      }
    });

    // Close results when clicking outside
    document.addEventListener("click", function (e) {
      if (
        !searchInput.contains(e.target) &&
        !resultsContainer.contains(e.target)
      ) {
        resultsContainer.style.display = "none";
      }
    });

    // Prevent Enter key from doing anything - just show results
    searchInput.addEventListener("keydown", function (e) {
      if (e.key === "Enter") {
        e.preventDefault();
        // Just prevent default - don't do anything
      }
    });
  })();

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
